<template>
  <div>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <product-item-show
            :id="id"
            :api_path="api_path"
            @gotAttrs="assignAttrs"
          ></product-item-show>
        </b-col>
        <b-col md="3">
          <collection-image-carousel-index
            :api_path="api_path"
            :filtering="filtering"
          ></collection-image-carousel-index>
        </b-col>
        <b-col md="5">
          <showing-carousel-index
            :api_path="api_path"
            :filtering="showing_filtering"
          ></showing-carousel-index>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ProductItemShow from './ProductItemShow.vue'
import CollectionImageCarouselIndex from './CollectionImageCarouselIndex.vue'
import ShowingCarouselIndex from './ShowingCarouselIndex.vue'

export default {
  components: {
    ProductItemShow,
    CollectionImageCarouselIndex,
    ShowingCarouselIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        product_item_ids: this.id
      },
      showing_filtering: {
        storage_space_path_ids: undefined
      },
      ams_template: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'brand-id': this.id
        }
      },
      attrs: undefined
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.showing_filtering.storage_space_path_ids = this.attrs['storage-space-id']
      this.ams_template.description = description
    }
  },
  mounted() {
    // const element = document.getElementById("jump-to-header")
    // element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>